var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var TikTokFilledIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 65,
    glyphHeight: 64
  }), React.createElement("path", {
    d: "M32.7585 0C15.089 0 0.758545 14.3304 0.758545 32C0.758545 49.6696 15.089 64 32.7585 64C50.4281 64 64.7585 49.6696 64.7585 32C64.7585 14.3304 50.4281 0 32.7585 0ZM47.5064 29.0783C45.6977 29.0783 43.889 28.6609 42.0803 27.9652C40.9672 27.5478 39.9933 26.8522 39.0194 26.1565V38.4C39.0194 41.1826 37.9064 43.687 35.9585 45.6348C34.289 47.1652 32.3412 48.2783 30.1151 48.5565C29.6977 48.6957 29.1412 48.6957 28.5846 48.6957C26.2194 48.6957 23.9933 48 22.1846 46.4696C21.9064 46.1913 21.489 45.913 21.2107 45.6348C19.1238 43.5478 18.0107 40.6261 18.1498 37.7043C18.289 35.4783 19.2629 33.2522 20.7933 31.5826C22.7412 29.3565 25.6629 28.1043 28.5846 28.1043C29.1412 28.1043 29.6977 28.1043 30.1151 28.2435V33.8087C29.6977 33.5304 29.1412 33.3913 28.5846 33.3913C25.802 33.3913 23.5759 35.6174 23.7151 38.4C23.7151 40.2087 24.689 41.7391 26.0803 42.5739C26.7759 42.9913 27.4716 43.2696 28.3064 43.2696C29.002 43.2696 29.5585 43.2696 30.1151 42.9913C32.0629 42.2957 33.4542 40.487 33.4542 38.2609V15.3043H38.8803C38.8803 15.8609 38.8803 16.4174 39.0194 16.8348C39.4368 18.9217 40.5498 20.7304 42.2194 21.8435C43.6107 22.9565 45.4194 23.513 47.2281 23.513V29.0783H47.5064Z"
  }));
};
export var TikTokFilledIconGlyph = function (props) {
  return React.createElement(TikTokFilledIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};